import indicativeGeo from "../data/mmr/indicativeGeo.json";
import { IQuantity } from "../interfaces";
import { includeVat } from "../utils";
import { defaultQuantity } from "./utils";

export function indicativeGeoPriceProvider(data: IQuantity, method: string) {
  const genuine = method === "mmr";
  const money = includeVat(
    indicativeGeo.price * data.quantity,
    !indicativeGeo.vat_included
  );
  return { investment: money, min: 0, max: 0, genuine };
}

export const indicativeGeoDefaultState: IQuantity = {
  quantity: defaultQuantity,
};
